<template>
  <div v-if="bar_chart && colWidthByType" class="columns is-align-items-center">
    <div :class="`column ${colWidthByType.display}`">
      <bar-chart
        v-if="
          bar_chart.type == 'V' && addChartData && addChartData.labels.length
        "
        :chartData="addChartData"
        :extraOptions="addExtraOptions"
        @data="isReceivingData"
      ></bar-chart>
      <horizontal-bar-chart
        v-else-if="
          bar_chart.type == 'H' && addChartData && addChartData.labels.length
        "
        :chartData="addChartData"
        :extraOptions="addExtraOptions"
        @data="isReceivingData"
      ></horizontal-bar-chart>
    </div>
    <div :class="`column ${colWidthByType.legend}`">
      <show-bar-chart-legend
        v-if="bar_chart.is_legend"
        :data="bar_chart.properties"
      />
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/Charts/BarChart";
import HorizontalBarChart from "@/components/Charts/HorizontalBarChart";
import ShowBarChartLegend from "@/components/Question/Charts/ShowBarChartLegend";
import { mapActions } from "vuex";

export default {
  props: {
    bar_chart: {
      type: Object,
    },
  },
  components: {
    BarChart,
    HorizontalBarChart,
    ShowBarChartLegend,
  },
  data() {
    return {
      clipartHeight: [10],
    };
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    checkAnswers() {
      let matched = 0;
      let total = 0;
      for (let i of this.bar_chart.properties) {
        if (i.answer) {
          total = total + 1;
        }
      }
      for (let j of this.bar_chart.properties) {
        if (j.value === j.answer && j.value && j.answer) {
          matched = matched + 1;
        }
      }
      if (matched == total) {
        this.updateCurrentAnswer({key : "bar_chart", value : true})
      } else {
        this.updateCurrentAnswer({key : "bar_chart", value : false})
      }
    },
    isReceivingData(vals) {
      this.bar_chart.properties[vals.index].value = vals.value;
      this.checkAnswers();
    },
  },
  computed: {
    addPaddingByHeight() {
      const height_arr = this.bar_chart.properties.map((bar) => {
        if (bar.clipart && bar.clipart.clipart) {
          return bar.clipart.height;
        }
        return 10;
      });
      const max_height = Math.max(...height_arr);

      return max_height;
    },
    colWidthByType() {
      const mapping = {
        V: { display: "is-7", legend: "is-5" },
        H: { display: "is-9", legend: "is-3" },
      };

      return mapping[this.bar_chart.type];
    },
    addChartData() {
      // alert(this.addPaddingByHeight)
      let chartData = {
        labels: [],
        datasets: [
          {
            label: "Bar Chart",
            borderWidth: 2,
            backgroundColor: [],
            data: [],
          },
        ],
        pointBorderColor: "#2554FF",
        images: [],
        bars: this.bar_chart.properties,
      };
      if (this.bar_chart.properties.length) {
        for (let bar of this.bar_chart.properties) {
          if (bar.clipart && bar.clipart.clipart) {
            chartData.labels.push("");
          } else {
            chartData.labels.push(bar.title);
          }
          chartData.datasets[0].data.push(bar.value);
          chartData.datasets[0].backgroundColor.push(bar.styles.bg_color);
          if (bar.clipart && bar.clipart.clipart) {
            chartData.images.push({
              file: bar.clipart.clipart.file,
              width: bar.clipart.width,
              height: bar.clipart.height,
            });
          } else {
            chartData.images.push(null);
          }
        }
        return chartData;
      }

      return chartData;
    },
    addExtraOptions() {
      let extraOptions = {
        animation: false,
        title: {
          display: true,
          text: this.bar_chart.title,
          fontStyle: this.bar_chart.is_title_bold ? "bold" : "normal",
          fontSize: 20,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                padding: this.bar_chart.type == "H" ? 60 : 10,
                fontColor: "#000",
                beginAtZero: false,
                suggestedMin: this.bar_chart.min_val,
                suggestedMax: this.bar_chart.max_val,
                stepSize: this.bar_chart.step_size,
              },
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea:
                  this.bar_chart.type === "V" && this.bar_chart.is_gridlines
                    ? true
                    : false,
              },
              scaleLabel: {
                display: true,
                labelString: this.bar_chart.y_title,
                fontStyle: this.bar_chart.is_y_title_bold ? "bold" : "normal",
                fontSize: 16,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                padding: this.bar_chart.type == "H" ? 10 : 50,
                fontColor: "#000",
                beginAtZero: true,
                suggestedMin: this.bar_chart.min_val,
                suggestedMax: this.bar_chart.max_val,
                stepSize: this.bar_chart.step_size,
              },
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea:
                  this.bar_chart.type === "H" && this.bar_chart.is_gridlines
                    ? true
                    : false,
              },
              scaleLabel: {
                display: true,
                labelString: this.bar_chart.x_title,
                fontStyle: this.bar_chart.is_x_title_bold ? "bold" : "normal",
                fontSize: 16,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      };

      return extraOptions;
    },
  },
};
</script>
